module.exports = __webpack_public_path__ + "un-global.a54a493.png";